import React from "react";

import { Tab, Tabs } from "react-bootstrap";

import ColumnsInfoTab from "components/dataAnalysisTabs/ColumnsInfoTab";
import DataAnalysisTab from "components/dataAnalysisTabs/DataAnalysisTab";
import AlgorithmTab from "components/dataAnalysisTabs/AlgorithmTab";
// import DataAnalysisTestTab from "components/dataAnalysisTabs/DataAnalysisTestTab";

const DataAnalysisDetailTab = ({ csvInfo, target, outputJson, outputHtml, outputMatrix }) => {
  if (outputMatrix) {
    return (
      <div className="mt-8">
        <div className="aiso-tab tab-3 border-none w-full">
          <Tabs defaultActiveKey="Tab1" id="uncontrolled-tab-example">
            <Tab eventKey="Tab1" title="컬럼 설명" className="test-tab">
              <ColumnsInfoTab csvInfo={csvInfo} target={target} />
            </Tab>
            <Tab eventKey="Tab2" title="데이터 분석" className="test-tab">
              <DataAnalysisTab outputHtml={outputHtml} />
            </Tab>
            <Tab eventKey="Tab3" title="알고리즘">
              <AlgorithmTab outputJson={outputJson} />
            </Tab>
            {/* <Tab eventKey="Tab4" title="학습 결과">
              <DataAnalysisTestTab outputMatrix={outputMatrix} />
            </Tab> */}
          </Tabs>
        </div>
      </div>
    );
  } else {
    return (
      <div className="mt-8">
        <div className="aiso-tab tab-3 border-none w-full">
          <Tabs defaultActiveKey="Tab1" id="uncontrolled-tab-example">
            <Tab eventKey="Tab1" title="컬럼 설명" className="test-tab">
              <ColumnsInfoTab csvInfo={csvInfo} target={target} />
            </Tab>
            <Tab eventKey="Tab2" title="데이터 분석" className="test-tab">
              <DataAnalysisTab outputHtml={outputHtml} />
            </Tab>
            <Tab eventKey="Tab3" title="알고리즘">
              <AlgorithmTab outputJson={outputJson} />
            </Tab>
          </Tabs>
        </div>
      </div>
    );
  }
};

export default DataAnalysisDetailTab;
